<template>
  <div id="view">
    <historyTag :historyArr="historyArr"></historyTag>
    <div id="mainBox">
      <div class="topBox flex toolbarRow">
        <div class="filterRow">
          <span class="filterLabel">敏感词</span>
          <el-input
            v-model="queryWord"
            clearable
            placeholder="模糊搜索"
            class="nameSearchInput"
            @keyup.enter.native="loadList"
          />
          <span class="filterLabel">业务场景</span>
          <el-select v-model="queryBizType" clearable placeholder="全部" style="width: 140px">
            <el-option
              v-for="item in bizTypeOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
          <span class="filterLabel">状态</span>
          <el-select v-model="queryStatus" clearable placeholder="全部" style="width: 120px">
            <el-option label="启用" :value="0" />
            <el-option label="停用" :value="1" />
          </el-select>
          <el-button type="primary" size="small" :loading="loading" @click="loadList">查询</el-button>
          <el-button size="small" :disabled="loading" @click="resetQuery">重置</el-button>
        </div>
        <el-button type="success" size="small" @click="openAdd">新增</el-button>
      </div>

      <el-table v-loading="loading" border :data="tableData" style="width: 100%">
        <el-table-column prop="word" label="敏感词" min-width="160" show-overflow-tooltip />
        <el-table-column label="业务场景" width="120" align="center">
          <template slot-scope="scope">
            {{ bizTypeLabel(scope.row.bizType) }}
          </template>
        </el-table-column>
        <el-table-column label="状态" width="88" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.status === 1 ? "停用" : "启用" }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="remark" label="备注" min-width="180" show-overflow-tooltip />
        <el-table-column label="操作" width="168" align="center" fixed="right">
          <template slot-scope="scope">
            <el-button type="success" size="small" @click="openEdit(scope.row)">编辑</el-button>
            <el-button type="danger" size="small" @click="delRow(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="520px"
      append-to-body
      :close-on-click-modal="false"
    >
      <el-form label-width="88px" class="dialogForm">
        <el-form-item label="敏感词" required>
          <el-input
            v-model="form.word"
            maxlength="128"
            show-word-limit
            placeholder="请输入敏感词"
            clearable
          />
        </el-form-item>
        <el-form-item label="业务场景" required>
          <el-select v-model="form.bizType" placeholder="请选择" style="width: 100%">
            <el-option
              v-for="item in bizTypeOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="状态">
          <el-radio-group v-model="form.status">
            <el-radio :label="0">启用</el-radio>
            <el-radio :label="1">停用</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="备注">
          <el-input
            v-model="form.remark"
            type="textarea"
            :rows="3"
            maxlength="256"
            show-word-limit
            placeholder="可选"
          />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialogFooter">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" :loading="submitShow" @click="submit">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { delTips, throttle } from "@/util/utils";

const BIZ_TYPE_OPTIONS = [
  { value: "nickname", label: "用户昵称" },
];

export default {
  data() {
    return {
      historyArr: ["系统管理", "敏感词库"],
      bizTypeOptions: BIZ_TYPE_OPTIONS,
      tableData: [],
      loading: false,
      submitShow: false,
      dialogVisible: false,
      dialogTitle: "",
      queryWord: "",
      queryBizType: "",
      queryStatus: null,
      form: {
        id: null,
        word: "",
        bizType: "nickname",
        status: 0,
        remark: "",
      },
    };
  },
  mounted() {
    this.loadList();
  },
  methods: {
    bizTypeLabel(type) {
      const item = this.bizTypeOptions.find((x) => x.value === type);
      return item ? item.label : type || "-";
    },
    emptyForm() {
      return {
        id: null,
        word: "",
        bizType: "nickname",
        status: 0,
        remark: "",
      };
    },
    resetQuery() {
      this.queryWord = "";
      this.queryBizType = "";
      this.queryStatus = null;
      this.loadList();
    },
    loadList() {
      this.loading = true;
      const payload = { page: 1, size: -1 };
      if (this.queryWord && this.queryWord.trim()) {
        payload.word = this.queryWord.trim();
      }
      if (this.queryBizType) {
        payload.bizType = this.queryBizType;
      }
      if (this.queryStatus === 0 || this.queryStatus === 1) {
        payload.status = this.queryStatus;
      }
      this.$https(this.$api.api.selSensitiveWord, payload, "POST")
        .then((res) => {
          if (res.data.code === 200) {
            this.tableData = res.data.data || [];
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    openAdd() {
      this.dialogTitle = "新增敏感词";
      this.form = this.emptyForm();
      this.dialogVisible = true;
    },
    openEdit(row) {
      this.dialogTitle = "编辑敏感词";
      this.form = {
        id: row.id,
        word: row.word || "",
        bizType: row.bizType || "nickname",
        status: row.status != null ? row.status : 0,
        remark: row.remark || "",
      };
      this.dialogVisible = true;
    },
    submit: throttle(function () {
      const word = (this.form.word || "").trim();
      if (!word) {
        this.$message.error("请输入敏感词");
        return;
      }
      const payload = {
        word,
        bizType: this.form.bizType || "nickname",
        wordType: "local",
        status: this.form.status != null ? this.form.status : 0,
        remark: (this.form.remark || "").trim() || null,
      };
      if (this.form.id) {
        payload.id = this.form.id;
      }
      const url = this.form.id
        ? this.$api.api.upSensitiveWord
        : this.$api.api.addSensitiveWord;
      this.submitShow = true;
      this.$https(url, payload, "POST")
        .then((res) => {
          if (res.data.code === 200) {
            this.$message.success("保存成功");
            this.dialogVisible = false;
            this.loadList();
          } else {
            this.$message.error(res.data.msg || "保存失败");
          }
        })
        .finally(() => {
          this.submitShow = false;
        });
    }, 800),
    delRow: delTips(function (row) {
      this.$https(this.$api.api.delSensitiveWord, { id: row.id }, "GET").then((res) => {
        if (res.data.code === 200) {
          this.$message.success("已删除");
          this.loadList();
        } else {
          this.$message.error(res.data.msg || "删除失败");
        }
      });
    }),
  },
};
</script>

<style scoped>
.toolbarRow {
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
}
.filterRow {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
}
.filterLabel {
  font-size: 13px;
  color: #606266;
}
.nameSearchInput {
  width: 180px;
}
.dialogForm {
  padding-right: 12px;
}
</style>



// WEBPACK FOOTER //
// src/pages/sensitiveWord/index.vue